import { AddToCartButton } from '../../Checkout'
import { Button } from '../../Theme'
import { LABELS } from '../../UiBlocks'
import { AddToWishlistButton } from '../../Wishlist'

import type { Product } from '../../UiBlocks'

interface ProductCardActionsProps {
  product: Product
}

/**
 * ProductCardActions - Action row of the UiBlocks ProductCard (passed through renderActions)
 *
 * Simple products get "Adauga in cos", the others link to the product page ("Vezi detalii").
 * The wishlist toggle is always shown.
 */
export function ProductCardActions({ product }: ProductCardActionsProps) {
  return (
    <div className="flex items-center justify-start gap-2">
      {product.productType === 'simple' ? (
        <AddToCartButton sku={product.sku} />
      ) : (
        <Button variant="addToCart" size="addToCart" asChild>
          <a href={product.url}>
            <span className="font-sec-font text-sm md:text-base lg:text-lg group-hover/addtocart:text-text-color transition-colors duration-300">
              {LABELS.VIEW_DETAILS}
            </span>
          </a>
        </Button>
      )}
      <AddToWishlistButton sku={product.sku} />
    </div>
  )
}
